import { call, put, delay } from "redux-saga/effects";
import { ordersApi } from "@services/api";
import { deleteItemFromCartActions, getCartActions } from "../slices";

function* deleteItemFromCartWorker({ payload }) {
  yield delay(300);
  try {
    yield put(deleteItemFromCartActions.pending());
    const response = yield call(ordersApi.deleteItemFromCart, payload);
    yield put(deleteItemFromCartActions.success(response));

    yield put(getCartActions.pending());
    const responseGet = yield call(ordersApi.getCart, payload);
    yield put(getCartActions.success(responseGet));
    // TODO: handle callback | onSuccess
  } catch (error) {
    yield put(deleteItemFromCartActions.failure(error));
    // TODO: handle callback | onFailure
  }
}

export { deleteItemFromCartWorker };
